import { z } from 'zod';

export const emptyRule = <I extends z.ZodTypeAny>(s: I) =>
  z.preprocess((v) => {
    if (v === null || v === undefined || typeof v !== 'string') return '';
    return v;
  }, s);

export const requiredString = (name: string, max?: number) => {
  let schema = z.string().min(1, { message: `${name} is required` });
  if (max) schema = schema.max(max, { message: `${name} is too long` });
  return emptyRule(schema);
};

export const optionalNumber = () => z.number().nullable().optional();
export const optionalBoolean = () => z.boolean().optional().nullable();
export const optionalString = () => emptyRule(z.string());

export const optionalArray = <T extends z.ZodTypeAny>(v: T) =>
  z.array(v).optional().default([]);

export const optionalObjectArray = <T extends z.ZodRawShape>(v: T) =>
  optionalArray(z.object(v));

export const optionalObject = <T extends z.ZodRawShape>(v: T) =>
  z.object(v).optional();

export const requiredUnion = <
  T extends readonly [z.ZodTypeAny, z.ZodTypeAny, ...z.ZodTypeAny[]],
>(
  types: T,
  name: string,
) =>
  z
    .union(types)
    .or(z.undefined())
    .refine((value) => value !== undefined, {
      message: `${name} is required`,
    });
